import RaisedButton from "./raisedButton.tsx";
import React from "react";

const ErrorButton = (props) => <RaisedButton {...props} color="error" />;
export default ErrorButton;
